/**
 * @flow
 * @relayHash 0ce27793182a60fbc12881d0db873039
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ShipmentSuggestPicksQueryVariables = {|
  itemId: string,
  quantityNeeded: number,
|};
export type ShipmentSuggestPicksQueryResponse = {|
  +suggestPicks: $ReadOnlyArray<{|
    +lotId: string,
    +lotNumber: string,
    +quantity: number,
    +warehouseLocationName: ?string,
  |}>
|};
export type ShipmentSuggestPicksQuery = {|
  variables: ShipmentSuggestPicksQueryVariables,
  response: ShipmentSuggestPicksQueryResponse,
|};
*/


/*
query ShipmentSuggestPicksQuery(
  $itemId: ID!
  $quantityNeeded: Float!
) {
  suggestPicks(itemId: $itemId, quantityNeeded: $quantityNeeded) {
    lotId
    lotNumber
    quantity
    warehouseLocationName
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "quantityNeeded",
    "type": "Float!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "suggestPicks",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "itemId",
        "variableName": "itemId"
      },
      {
        "kind": "Variable",
        "name": "quantityNeeded",
        "variableName": "quantityNeeded"
      }
    ],
    "concreteType": "PickSuggestion",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "lotId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "lotNumber",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "quantity",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "warehouseLocationName",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ShipmentSuggestPicksQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ShipmentSuggestPicksQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ShipmentSuggestPicksQuery",
    "id": null,
    "text": "query ShipmentSuggestPicksQuery(\n  $itemId: ID!\n  $quantityNeeded: Float!\n) {\n  suggestPicks(itemId: $itemId, quantityNeeded: $quantityNeeded) {\n    lotId\n    lotNumber\n    quantity\n    warehouseLocationName\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f2a61f75c49dca83188747d2f462a77d';
module.exports = node;
